<template>
	<router-view />
	<new-order-modal
		ref="newOrderModal"
		:order-id="newOrderId"
		:isDumb="dumbOrder"
		@updateLocalOrder="updateLocalOrder"
		@rejectOrder="showRejectModal = true"
		@openCookingTimeModal="openCookingTimeModal"
		@close="closeModal"
	/>
	<cooking-time-modal
		v-if="isAccepted"
		:order="this.$refs.newOrderModal.order"
		@updateLocalOrder="updateLocalOrder"
		@rerenderTimer="rerenderTimer"
		@close="isAccepted = false"
	/>
	<reject-order-modal
		v-if="showRejectModal"
		:orderId="newOrderId"
		@close="showRejectModal = false"
		@updateLocalOrder="updateLocalOrder"
	/>
	<print-order-modal />
	<print-b2b-order-modal />
	<print-b2b-label-modal />
	<print-timeslot-items-modal />
	<print-daily-items-modal />
	<app-notification-warning-modal v-if="showNotificationModal" />
</template>

<script>
	import firebase from 'firebase/app';
	import 'firebase/messaging';
	import { Howl } from 'howler';
	import NewOrderModal from '@/components/orders/NewOrderModal';
	import PrintOrderModal from '@/components/orders/PrintOrderModal';
	import { statuses } from '@/constants/mapOrderStatuses';
	import OrderService from '@/services/OrderService';
	import PrintB2bOrderModal from '@/components/b2bOrders/PrintB2bOrderModal.vue';
	import PrintTimeslotItemsModal from '@/components/b2bOrders/PrintTimeslotItemsModal.vue';
	import PrintDailyItemsModal from '@/components/b2bOrders/PrintDailyItemsModal.vue';
	import AuthService from '@/services/AuthService';
	import RouteNames from '@/router/names';
	import { mapGetters } from 'vuex';
	import AppNotificationWarningModal from '@/components/app/AppNotificationWarningModal.vue';
	import PrintB2bLabelModal from '@/components/b2bOrders/PrintB2bLabelModal.vue';
	import CookingTimeModal from '@/components/orders/CookingTimeModal.vue';
	import RejectOrderModal from '@/components/orders/RejectOrderModal.vue';

	window.addEventListener('backgroundNotification', (event) => {
		console.log(event);
	});

	export default {
		components: {
			PrintB2bLabelModal,
			RejectOrderModal,
			CookingTimeModal,
			AppNotificationWarningModal,
			PrintDailyItemsModal,
			PrintTimeslotItemsModal,
			PrintB2bOrderModal,
			PrintOrderModal,
			NewOrderModal,
		},
		computed: {
			...mapGetters({
				user: 'user',
				isB2B: 'isB2B',
			}),
		},
		data: () => ({
			newOrderId: null,
			dumbOrder: false,
			messaging: firebase.messaging(),
			sound: null,
			showNotificationModal: false,
			showRejectModal: false,
			isAccepted: false,
		}),
		methods: {
			async startFireBase() {
				try {
					// Check if browser supports notifications
					if (!('Notification' in window)) {
						console.warn('This browser does not support notifications.');
						return;
					}
					// Request notification permission
					const permission = await Notification.requestPermission();
					if (permission !== 'granted') {
						console.warn('Notification permission denied.');
						if (this.user?.regId) this.logout();
						this.showNotificationModal = true;
						return;
					}
					// Ensure Firebase is available
					if (!firebase?.messaging) {
						console.error('Firebase Messaging is not initialized properly.');
						return;
					}
					// Get FCM Token
					const token = await this.messaging.getToken({ vapidKey: process.env.VAPID_KEY });
					if (token) {
						if (this.user && this.user.id && this.user.regId !== token) {
							this.updateTokenOnServer(token);
						}
						window.firebaseToken = token;
					} else {
						console.warn('No FCM token available.');
					}
				} catch (error) {
					console.error('Error initializing Firebase Messaging:', error);
				}
			},
			updateTokenOnServer(token) {
				AuthService.updateRegId(this.user.id, token)
					.then(() => {
						console.log('Token updated');
					})
					.catch(() => {
						console.error('Failed to update token on server');
					});
			},
			listenForMessages() {
				try {
					this.messaging.onMessage((payload) => {
						const { orderid, orderStatus } = payload.data;
						if (orderStatus === statuses.accepted) {
							OrderService.getOrder(orderid).then((order) => {
								this.emitter.emit('printOrder', order);
							});
						} else {
							this.sound.play();
							this.emitter.emit('onNewOrderReceived', { orderId: payload.data.orderid });
						}
					});
				} catch (e) {
					console.log(e);
				}
			},
			setupSound() {
				this.sound = new Howl({
					html5: true,
					src: `audio/shortRing.mp3`,
					volume: 1,
				});
				this.sound.stop();
			},
			updateLocalOrder(event) {
				this.emitter.emit('updateLocalOrder', event);
				this.closeModal();
			},
			rerenderTimer(orderId) {
				this.emitter.emit('rerenderTimer', orderId);
			},
			openCookingTimeModal() {
				this.closeModal();
				this.isAccepted = true;
			},
			closeModal() {
				this.newOrderId = null;
			},
			logout() {
				AuthService.deleteRegId(this.user.id, this.user.regId)
					.then(() => {
						if (this.isB2B) {
							this.$router.push({ name: RouteNames.B2B_Login });
						} else {
							this.$router.push({ name: RouteNames.Login });
						}
					})
					.catch(() => {
						this.$notificationService.error('Checkout Failed');
					})
					.finally(() => {
						this.$store.dispatch('logout');
					});
			},
		},
		mounted() {
			this.startFireBase();
			this.listenForMessages();
			this.setupSound();
			this.emitter.on('onNewOrderReceived', ({ orderId, isDumb }) => {
				this.newOrderId = orderId;
				this.dumbOrder = isDumb;
			});
		},
		beforeUnmount() {
			this.emitter.off('onNewOrderReceived', null);
		},
	};
</script>
